import { LeadCreateRequest } from './lead-create.request';
export const createMockedCreateLeadRequest = (customValues = {}) => {
    const request = new LeadCreateRequest();
    request.landingName = customValues.landingName ?? 'Onboarding Landing';
    request.clientName = customValues.clientName ?? 'Ada Lovelace';
    request.companyName = customValues.companyName ?? 'ACME Consulting';
    request.contactEmail = customValues.contactEmail ?? 'hello@adalovelace.com';
    request.createPipedriveLead = customValues.createPipedriveLead ?? true;
    request.isMql = customValues.isMql ?? true;
    request.isSubscribeToNewsletter = customValues.isSubscribeToNewsletter ?? true;
    request.recaptchaToken = customValues.recaptchaToken ?? 'token-1234';
    return request;
};
//# sourceMappingURL=lead-create.request.mock.js.map